var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 21.5027H15.1666L9.97497 24.956C9.20497 25.4693 8.16665 24.921 8.16665 23.9877V21.5027C4.66665 21.5027 2.33331 19.1693 2.33331 15.6693V8.66927C2.33331 5.16927 4.66665 2.83594 8.16665 2.83594H19.8333C23.3333 2.83594 25.6666 5.16927 25.6666 8.66927V15.6693C25.6666 19.1693 23.3333 21.5027 19.8333 21.5027Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.2539V13.009C14 12.2156 14.49 11.7956 14.98 11.4573C15.4584 11.1306 15.9366 10.7106 15.9366 9.94061C15.9366 8.86728 15.0733 8.00391 14 8.00391C12.9267 8.00391 12.0634 8.86728 12.0634 9.94061",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9948 16.0423H14.0053",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.4ec3038d8de9f6a7ccf327a3ebb2dfce.svg";
export { ForwardRef as ReactComponent };